/* global globalThis */
import React from "react";

export default function AccessDenied() {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-200/30 backdrop-blur-xl w-full h-full"
      aria-label="Access Denied"
    >
      <div
        className="bg-white rounded-2xl shadow-xl"
        style={{ maxWidth: "400px", cursor: "default" }}
      >
        <div className="flex flex-col items-center justify-center p-6 text-center">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-5">
            <svg
              className="w-8 h-8 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Access Denied</h3>
          <p className="text-sm text-gray-500 mb-8 font-medium">
            You do not have access to Admin settings. Please contact your
            administrator to request access permissions.
          </p>
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-xl border border-transparent px-5 py-3 bg-blue-600 text-sm font-semibold text-white shadow hover:bg-blue-700 transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            onClick={() => {
              globalThis.location.href = "/";
            }}
          >
            Go Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
